// @flow

import React from "react";

import { Title as StyledTitle } from "./styles";
import Title from "./index";

import type { RoomId } from "src/types";

type Props = {
  type: string,
  title: string,
  templateId: ?number,
  seqNo: number,
  canceled: ?boolean,
  roomId: RoomId,
};

const Medium = ({ canceled, ...rest }: Props) => (
  <StyledTitle canceled={canceled}>
    <Title {...rest} />
  </StyledTitle>
);

export default Medium;
